/**
 * 환경변수 등. 다른 모듈과 상호 영향 없도록 pure function 및 속성 지정할 것. import 금지
 * local server에서 사용하기 때문에 CommonJs 방식
 */

module.exports = {
  baseUrl: process.env.BASE_URL,
  isLocalDevelopmentServer: process.env.NODE_ENV === 'development',
  proxyServer: process.env.VUE_APP_PROXY_SERVER
}
